// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Canvas_wrapper__3hAG3","canva":"Canvas_canva__1nX22"};